import type { AdminUseSelectListDto } from '@@types/api.types';
import { Badge } from '@components/ui/badge';
import type { ColumnDef } from '@tanstack/react-table';

export const createUsesColumns = (): ColumnDef<AdminUseSelectListDto>[] => [
  {
    id: 'name',
    accessorFn: (row) => row.name,
    header: 'Name',
    size: 360,
    sortingFn: 'text',
    cell: ({ row }) => <div className="font-medium text-gray-900">{row.original.name}</div>,
  },
  {
    id: 'status',
    accessorFn: (row) => row.archived,
    header: 'Status',
    size: 160,
    sortingFn: 'text',
    cell: ({ row }) => {
      const archived = row.original.archived;
      const variant = archived ? 'warning' : 'success';
      const label = archived ? 'Archived' : 'Available';
      return (
        <Badge
          size="xs"
          variant={variant}
        >
          {label}
        </Badge>
      );
    },
  },
];
